import React, { useState } from "react";
import { Box, Button, Checkbox, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PaymentButton = ({ onPay, disabled, paymentMethod, isPartner = false }) => {
  const { t } = useTranslation("common");
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  const linkSx = { color: "#1E88E5", fontWeight: "bold", cursor: "pointer" };

  return (
    <Box sx={{ padding: 3, mt: 2 }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5, mb: 1, mt: 1 }}>
        <Checkbox
          checked={agreed}
          disableRipple
          onChange={() => setAgreed(!agreed)}
          sx={{
            p: 0.5,
            color: "#757575",
            "&:hover": { backgroundColor: "transparent" },
          }}
        />
        <Typography variant="body2" sx={{ color: "#333" }}>
          {t("checkout.confirmPrefix")}
          <Typography
            onClick={() => navigate("/privacy-policy")}
            component="span"
            sx={linkSx}
          >
            {t("checkout.privacyPolicy")}
          </Typography>
          {t("checkout.confirmAnd")}
          <Typography
            onClick={() => navigate("/offer")}
            component="span"
            sx={linkSx}
          >
            {t("checkout.confirmOffer")}
          </Typography>
          {t("checkout.confirmMiddle")}
          <Typography
            onClick={() => navigate("/terms-and-conditions")}
            component="span"
            sx={linkSx}
          >
            {t("checkout.termsAndConditions")}
          </Typography>
          {isPartner ? t("checkout.confirmPartnerNote") : null}
        </Typography>
      </Box>

      <Button
        variant="contained"
        fullWidth
        sx={{
          backgroundColor: agreed ? "#1E3A8A" : "#C0C0C0",
          color: agreed ? "#fff" : "#333",
          fontWeight: "bold",
          fontSize: "16px",
          padding: "12px",
          borderRadius: "8px",
          textTransform: "none",
          "&:hover": {
            backgroundColor: agreed ? "#1E3A8A" : "#C0C0C0",
            color: agreed ? "#fff" : "#333",
          },
        }}
        disabled={disabled ?? !agreed}
        onClick={onPay}
      >
        {paymentMethod === "card" ? t("checkout.pay") : t("checkout.book")}
      </Button>
    </Box>
  );
};

export default PaymentButton;
